import { B2BOptPropertiesTypes } from "@website/widget/login/components/b2b-otp/b2b-otp.types";
import { AuthB2BVerifyOtpService } from "@website/widget/login/services/auth-b2b-verify-otp";
import { AuthRequestOtpService } from "@website/widget/login/services/auth-request-otp";
import { useCallback, useState } from "react";

export const useB2BOtp = (properties: B2BOptPropertiesTypes) => {
  const { userData, onEndAuth, setStep, setUserData } = properties;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSendAgain, setIsLoadingSendAgain] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [showSendAgain, setShowSendAgain] = useState<boolean>(false);

  const onChangeOtp = useCallback((value: string) => {
    setOtp(value);
  }, []);

  const onSubmitOtp = useCallback(
    async (_event: React.FormEvent<HTMLFormElement>) => {
      _event.preventDefault();
      const { otpId, otpLength, contractId } = userData;
      if (otp.length === otpLength) {
        setIsLoading(true);
        setError("");
        if (otpId) {
          AuthB2BVerifyOtpService({
            otp,
            otpId,
            companyCode: String(contractId)
          })
            .then((data) => {
              const { accessToken, hasPassword, refreshToken, userExists } =
                data;
              if (accessToken) {
                setUserData({
                  ...userData,
                  accessToken,
                  hasPassword,
                  refreshToken,
                  userExists
                });
                onEndAuth?.(accessToken, refreshToken);
              }
            })
            .catch((error) => {
              setError(
                error?.response?.message ||
                  error?.response?.data?.message ||
                  "خطایی رخ داده، دوباره تلاش کنید."
              );
            })
            .finally(() => setIsLoading(false));
        } else {
          setError("کد را وارد کنید");
        }
      }
    },
    [userData, otp, setUserData, onEndAuth]
  );

  const onTimerEnd = useCallback(() => {
    setShowSendAgain(true);
  }, []);

  const onClickSendAgain = useCallback(async () => {
    const { phoneNumber } = userData;
    setIsLoadingSendAgain(true);
    setError("");
    AuthRequestOtpService({ phoneNumber })
      .then((data) => {
        setUserData({ ...userData, ...data });
        setShowSendAgain(false);
      })
      .catch((error) => {
        setError(
          error?.response?.data?.message || "خطایی رخ داده، دوباره تلاش کنید."
        );
      })
      .finally(() => setIsLoadingSendAgain(false));
  }, [setUserData, userData]);

  const onBackClick = useCallback(() => {
    const { forgotPassword } = userData;
    if (forgotPassword) {
      setStep("password");
    } else {
      setStep("phone-number");
    }
  }, [setStep, userData]);

  return {
    isLoading,
    otp,
    onChangeOtp,
    onSubmitOtp,
    error,
    onBackClick,
    onTimerEnd,
    showSendAgain,
    onClickSendAgain,
    isLoadingSendAgain
    // onPasswordClick,
  };
};
